import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { errorBoundary, sendTelemetryErrorEvent } from '~commonInfra/components/ErrorBoundary';
import { MapDispatchToProps,MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { clearSpaceContentCountsAction } from '~src/spacesPlatform/actions/ContentCountsActions';
import { createNewWorkbook } from '~src/spacesPlatform/actions/ContentExplorerCreateActions';
import { showContentTypes } from '~src/spacesPlatform/actions/ContentExplorerFilterActions';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '~src/spacesPlatform/selectors/ContentFilterSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { getPersonalSpace } from '../../actions/PersonalSpaceActions';
import { selectPersonalSpace } from '../../selectors/PersonalSpaceSelector';
import {
  PersonalSpace,
  PersonalSpaceDispatchProps,
  PersonalSpaceOwnProps,
  PersonalSpaceStateProps} from './PersonalSpace';

const mapStateToProps: MapStateToProps<PersonalSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state),
  personalSpace: selectPersonalSpace(state)
});

const mapDispatchToProps: MapDispatchToProps<PersonalSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    filterSelected: showContentTypes,
    requestSpaceContents,
    clearContentCounts: clearSpaceContentCountsAction,
    getPersonalSpace,
    createNewWorkbook
  }, dispatch);

const ConnectedPersonalSpaceInternal: React.ComponentClass<PersonalSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(PersonalSpace);

export const ConnectedPersonalSpace =
  errorBoundary<PersonalSpaceOwnProps>
    (sendTelemetryErrorEvent)(ConnectedPersonalSpaceInternal);
